module.exports = __webpack_public_path__ + "static/media/noCommodity.da1c1c6a.png";